import classNames from 'classnames';
import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';

import Button from '../../../../../components/common/button/button';
import { Translate } from '../../../../../components/translate/translate';

import styles from './team-member-form-footer.scss';
import { Loader, TextButton } from '@wix/design-system';

interface OwnProps {
  className?: string;
  invalid: boolean;
  submitButtonText: React.ReactNode;
  submitting: boolean;
  onAddTeamMemberAccess(): void;

  onCancel(): void;
}

type Props = OwnProps & WrappedComponentProps;

const TeamMemberFormFooterComponent = ({
  className,
  invalid,
  onAddTeamMemberAccess,
  onCancel,
  submitButtonText,
  submitting,
}: Props) => {
  return (
    <div className={classNames(styles.footer, className)}>
      <TextButton
        dataHook="team-member-access-button"
        onClick={onAddTeamMemberAccess}
      >
        <Translate transKey="team.add-member-modal.add-access-button.title" />
      </TextButton>

      <div className={styles.formActionButtons}>
        <div className={styles.cancelButton}>
          <Button
            dataHook="team-member-form-cancel-button"
            priority="secondary"
            onClick={onCancel}
          >
            <Translate transKey="team.add-member-modal.cancel-text" />
          </Button>
        </div>

        <Button
          type="submit"
          dataHook="organization-team-member-form-submit-button"
          disabled={invalid}
        >
          {submitting ? <Loader size="tiny" /> : submitButtonText}
        </Button>
      </div>
    </div>
  );
};

export const TeamMemberFormFooter = injectIntl(TeamMemberFormFooterComponent);
